import { render, staticRenderFns } from "./CompraDelete.vue?vue&type=template&id=7dcaf001"
import script from "./CompraDelete.vue?vue&type=script&lang=js"
export * from "./CompraDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports